import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick-pnth";
import PrevArrow from "./prevarrow";
import NextArrow from "./nextarrow";
import "./newsCarousel.css";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import Anchor from "../Link/anchor";
import { Link } from "react-router-dom";
import LazyImg from "../lazy/lazy";
import Icon from "../icon/icon";
import { BORDER, RTL, VCMS } from "../../global";

const NewsCarousel = (props) => {
  const mounted = useRef(false);
  const init = { playlist: [] };
  const y_init = { items: [] };
  const [elemnc, setElemNc] = useState([]);
  const [elemItemnc, setItemNc] = useState([]);
  const [playlistnc, setPlaylistNc] = useState(
    VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [elemdisplaync, setElemDisplayNc] = useState(true);
  const settings = {
    centerMode: true,
    centerPadding: props.multiple ? "300px" : "0px",
    rtl: RTL,
    slidesToShow: 1,
    nextArrow: <NextArrow></NextArrow>,
    prevArrow: <PrevArrow></PrevArrow>,
    arrows: true,
    dots: true,
    autoplay: props.information.autoPlay,
    autoplaySpeed: parseInt(props.information.autoPlayTimer),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
          rtl: RTL,
          centerMode: true,
          centerPadding: props.multiple ? "20px" : "0px",
          slidesToShow: 1,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          rtl: RTL,
          centerMode: true,
          centerPadding: props.multiple ? "20px" : "0px",
          slidesToShow: 1,
          dots: false,
        },
      },
    ],
  };

  useEffect(() => {
    mounted.current = true;
    const ElemDetailNews = async (app, id) => {
      if (mounted.current) {
        /* eslint-disable no-unused-vars */
        setElemNc(props.information);
        if (
          props.information.playlistId !== "" &&
          props.information.playlistId !== null
        ) {
          playlistDetail(
            props.information.playlistId,
            props.information.devices[0].itemSize
          );
        }
        setElemDisplayNc(props.information.devices[0].itemVisibility);
        setItemNc(props.information.items);
        /* eslint-disable no-unused-vars */
      }
    };

    const playlistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */
      if (VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setPlaylistNc(result.data);
              isLoading(false);
            }
          },
          (error) => {
            if (mounted.current) {
              SetError(true);
            }
          }
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setPlaylistNc(result.data);
              isLoading(false);
            }
          },
          (error) => {
            if (mounted.current) {
              SetError(true);
            }
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };

    ElemDetailNews();
    isLoading(false);

    return () => {
      mounted.current = false;
    };
  }, [props.information]);

  if (elemdisplaync && !error && !loading && props.information) {
    return (
      <section className="news iq-main-slider p-0">
        <Slider className="tvshows-slider" {...settings}>
          {elemItemnc !== null
            ? elemItemnc.map((item, index) =>
                item.itemid.devices[0].itemVisibility ? (
                  <div key={index}>
                    <Anchor
                      to={
                        item.itemid.pageType === "externalPage"
                          ? item.itemid.externalPage
                          : item.itemid.pageType === "internalPage"
                          ? item.itemid.internalPage
                          : item.itemid.pageType === "videoPage"
                          ? "/" +
                            props.match.params.AppId +
                            "/" +
                            item.itemid.pageType +
                            "/" +
                            item.itemid.videoId
                          : item.itemid.urlName !== ""
                          ? "/" +
                            props.match.params.AppId +
                            "/" +
                            item.itemid.urlName
                          : item.itemid.pageType + "/" + item.itemid._id
                      }
                    >
                      <div className="shows-img">
                        <LazyImg
                          src={
                            item.itemid.bannerImage
                              ? getAWSUrl() + item.itemid.bannerImage.imagekey
                              : ""
                          }
                          className={BORDER ? "w-100" : "w-100 no-border"}
                          alt=""
                          orient="landscape"
                        />
                      </div>
                    </Anchor>
                  </div>
                ) : (
                  <div
                    key={index}
                    className="none"
                    style={{ display: "none" }}
                  ></div>
                )
              )
            : ""}

          {elemnc.playlistId !== null && elemnc.playlistId !== undefined
            ? VCMS === "YouTube"
              ? playlistnc.items.map((item, index) => (
                  <div key={index}>
                    <Link
                      to={
                        "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.contentDetails.videoId
                      }
                    >
                      <div className="shows-img">
                        {/* {item.ContentType==="Premium"?<Icon></Icon>:""} */}
                        <LazyImg
                          src={
                            "https://i.ytimg.com/vi/" +
                            item.contentDetails.videoId +
                            "/maxresdefault.jpg"
                          }
                          className={BORDER ? "w-100" : "w-100 no-border"}
                          alt=""
                          orient="landscape"
                        />
                      </div>
                    </Link>
                  </div>
                ))
              : playlistnc.playlist.map((item, index) => (
                  <div key={index}>
                    <Link
                      to={
                        "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.mediaid
                      }
                    >
                      <div className="shows-img">
                        {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                        <LazyImg
                          src={item.image}
                          className={BORDER ? "w-100" : "w-100 no-border"}
                          alt=""
                          orient="landscape"
                        />
                      </div>
                    </Link>
                  </div>
                ))
            : ""}
        </Slider>
      </section>
    );
  } else if (elemdisplaync && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default NewsCarousel;
